// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { shareEntityButtonStyles } from "@vanmeter/Overrides/Components/ShareEntityButton";
import { mergeWithCss, modalButtonsActionStyles } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

shareEntityButtonStyles.messageTextArea = {
    css: css`
        resize: vertical;
    `,
};

shareEntityButtonStyles.button = {
    variant: "secondary",
};

shareEntityButtonStyles.container = {
    gap: 20,
};

shareEntityButtonStyles.buttonsWrapper = {
    ...mergeWithCss(modalButtonsActionStyles.buttonsGridItem, {
        css: css`
            margin-top: 20px;
        `,
    }),
};

shareEntityButtonStyles.cancelButton = {
    ...modalButtonsActionStyles.cancelButton,
};

shareEntityButtonStyles.sendButton = {
    ...modalButtonsActionStyles.submitButton,
};

shareEntityButtonStyles.notifyMsg = {
    css: css`
        max-width: unset;
        margin-bottom: 0;
    `,
};

shareEntityButtonStyles.printButtonGridItem = {
    width: 12,
};
